import React, { useMemo } from "react";
import _ from "lodash";
import { pushDatatoAdobeLayer } from '../../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsSocailListObj } from '../../../analytics/analyticsObject';
import { getUrlWithoutPathname } from '../../../utils/utility';

const CardFilterPills = ({ post, lookup, canProceed, cardFilterSelected }) => {
  const filters = useMemo(() => {
    const result = [];
    const postPmApproch = post?.pmApproach;
    const postSubTopic = post?.subTopic;
    if (postPmApproch) {
      postPmApproch.forEach((item) => {
        const lookupItem = item?.id || item
        const lookupObject = _.find(lookup, { key: lookupItem });
        if (lookupObject && lookupItem !== "PMNotSpecific") result.push(lookupObject);
      });
    }
    if (post.industry) {
      post.industry.forEach((item) => {
        const lookupItem = item?.id || item
        const lookupObject = _.find(lookup, { key: lookupItem });
        if (lookupObject) result.push(lookupObject);
      });
    }
    if (post.topic) {
      post.topic.forEach((item) => {
        const lookupItem = item?.id || item
        const lookupObject = _.find(lookup, { key: lookupItem });
        if (lookupObject) result.push(lookupObject);
      });
    }
    if (postSubTopic) {
      postSubTopic.forEach((item) => {
        const lookupItem = item?.id || item
        const lookupObject = _.find(lookup, { key: lookupItem });
        if (lookupObject) result.push(lookupObject);
      });
    }
    return result;
  }, [post, lookup]);

  const navigateToFilter = (filter) => {
    if (post.clickDisabled !== true) {
      let filtersHash = filter.key
      window.location = "home#" + filtersHash;
    }
  }

  const adobeCustomLog = (filter) => {
    let selectedFilter = filter.group + ':' + filter.title
    let contEventObj = getAdobeAnalyticsEventObject(
      "search-filter",
      "search-filter",
    );
    let contObj = getAdobeAnalyticsSocailListObj({
      search: {
        searchFilter: selectedFilter
      }
    });
    let linkUrl = `${getUrlWithoutPathname()}`
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'filter',
      "card-content",
      linkUrl
    );
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    pushDatatoAdobeLayer({
      onContClickData: { ...contEventObj, ...contObj },
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div className="flex flex-wrap items-center mt-3 mb-4" adoberegion="card-content">
      {filters.map((filter, index) => (
        <span
          onClick={() => { cardFilterSelected && cardFilterSelected(filter) || navigateToFilter(filter); adobeCustomLog(filter) }}
          className={
            "px-4 py-1 border border-gray-400 text-gray-400 text-sm rounded-full mr-2 mt-1 cursor-pointer hover:bg-blue-600 hover:text-white hover:border-white pressura " +
            (post.status !== "Published" ? "bg-blue-700" : "bg-white")
          }
          key={filter.key || index}
        >
          {filter.title}
        </span>
      ))}
    </div>
  );
};

export default CardFilterPills;
